export default "__VITE_ASSET__d6aee4e6__"